import { z } from "zod/v4";

// z.tuple types items spread from an array as [], so its output is re-typed once the length is checked.
export const tupleOf = <T>(
  schemas: readonly [z.ZodType<T, unknown>, ...z.ZodType<T, unknown>[]],
): z.ZodType<[T, ...T[]], unknown> =>
  z
    .unknown()
    .pipe(z.tuple([...schemas]))
    .pipe(z.any())
    .pipe(
      z.custom<[T, ...T[]]>(
        (values) => Array.isArray(values) && values.length === schemas.length,
      ),
    );
